function getTranslation(obj, key) {
    if (!obj) return null;
    return key.split('.').reduce((o, i) => (o ? o[i] : null), obj);
}

// Global helper for JS files
window.T = function(key, fallback = '') {
    const lang = document.documentElement.lang || 'en';
    const translations = window['i18n_' + (lang.includes('-') ? lang.replace('-', '_') : lang)];
    if (!translations) return fallback || key;
    return getTranslation(translations, 'dynosim.auto.' + key) || fallback || key;
};

function updateI18nBridge() {
    const lang = document.documentElement.lang || 'en';
    const t = window['i18n_' + (lang.includes('-') ? lang.replace('-', '_') : lang)];
    if (!t || !window.dynosim_i18n) return;
    const d = t.dynosim && t.dynosim.auto;
    if (!d) return;

    Object.keys(window.dynosim_i18n).forEach(bridgeKey => {
        if (d[bridgeKey]) {
            window.dynosim_i18n[bridgeKey] = d[bridgeKey];
        }
    });
}

function switchLanguage(lang) {
    const translations = window['i18n_' + lang];
    if (!translations) {
        console.error('[i18n] Translations not loaded for:', lang);
        return;
    }
    document.querySelectorAll('[data-t]').forEach(el => {
        const val = getTranslation(translations, 'dynosim.auto.' + el.getAttribute('data-t'));
        if (val) el.innerHTML = val;
    });
    document.querySelectorAll('[data-i18n]').forEach(el => {
        const val = getTranslation(translations, el.getAttribute('data-i18n'));
        if (val) el.innerHTML = val;
    });
    document.documentElement.lang = lang;
    updateI18nBridge();
    localStorage.setItem('dynosim_lang', lang);
    if (typeof renderUpgradesUI === 'function') renderUpgradesUI();
    console.log('[i18n] Switched to', lang);
}

// Restore saved language on load
document.addEventListener('DOMContentLoaded', () => {
    const saved = localStorage.getItem('dynosim_lang');
    if (saved && saved !== 'en') {
        const sel = document.getElementById('lang-selector');
        if (sel) sel.value = saved;
        switchLanguage(saved);
    }
});
